import { defineType } from 'sanity';

export const videoSection = defineType({
    name: 'videoSection',
    title: 'Video section',
    type: 'object',
    fields: [
        {
            name: 'title',
            title: 'Title',
            type: 'localizedString',
        },
        {
            name: 'description',
            title: 'Description',
            type: 'localizedText',
        },
        {
            name: 'videoUrl',
            title: 'Video URL',
            type: 'string',
        },
        {
            name: 'thumbnailImage',
            title: 'Thumbnail Image',
            type: 'seoOptimizedImageUrl',
        },
        {
            name: 'variant',
            title: 'Variant',
            type: 'string',
            options: {
                list: [
                    { title: 'Variant A', value: 'A' },
                    { title: 'Variant B', value: 'B' },
                    { title: 'Variant C', value: 'C' },
                ],
            },
        },
    ],
    preview: {
        select: {
            title: 'title',
        },
        prepare({ title }) {
            return {
                title: `Video Section: ${title['en'] || title['sr']}`,
            };
        },
    },
});
